import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Card, Button, Badge } from '../ui';

const Doacoes = () => {
    const whatsappLink = "https://wa.link/rntc9u";

    return (
        <section id="doacoes" className="doacoes-section py-5">
            <div className="container">
                <InViewComponent delay={0}>
                    <div className="text-center mb-5">
                        <Badge variant="primary" size="md" className="mb-3">Contribua</Badge>
                        <h2 className="doacoes-titulo mb-3">Sua Generosidade Transforma Vidas</h2>
                        <p className="doacoes-subtitulo mx-auto">
                            Cada contribuição nos ajuda a continuar nossa missão de espalhar amor e esperança.
                        </p>
                    </div>
                </InViewComponent>

                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">
                        <InViewComponent delay={0.1}>
                            <Card className="doacoes-card-main">
                                <Card.Body className="text-center p-5">
                                    <div className="doacoes-heart-icon mb-4">
                                        <i className="bi bi-heart-fill"></i>
                                    </div>
                                    
                                    <h3 className="mb-3" style={{ color: 'var(--primary-color)' }}>
                                        Faça Sua Doação
                                    </h3>
                                    
                                    <p className="text-muted mb-4">
                                        Sua contribuição é muito importante para nos ajudar a continuar 
                                        com nossos projetos e missões. Entre em contato conosco pelo 
                                        WhatsApp para realizar sua doação.
                                    </p>
                                    
                                    <Button
                                        onClick={() => window.open(whatsappLink, '_blank')}
                                        variant="primary"
                                        size="lg"
                                        className="doacoes-whatsapp-btn"
                                    >
                                        <i className="bi bi-whatsapp me-2"></i>
                                        Doar via WhatsApp
                                    </Button>
                                    
                                    <p className="mt-4 mb-0 small text-muted">
                                        <i className="bi bi-shield-check me-1"></i>
                                        Todas as doações são seguras
                                    </p>
                                </Card.Body>
                            </Card>
                        </InViewComponent>
                    </div>
                </div>
            </div>
        </section>
    );
}

const InViewComponent = ({ children, delay = 0 }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView({
        threshold: 0.1,
        triggerOnce: true
    });

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [controls, inView]);

    return (
        <motion.div
            ref={ref}
            initial="hidden"
            animate={controls}
            transition={{ duration: 0.6, delay, ease: "easeInOut" }}
            variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0 }
            }}
        >
            {children}
        </motion.div>
    );
}

export default Doacoes;

